import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ArrowRight } from './icons';
import './Breadcrumbs.css';

function Breadcrumbs({ crumbs }) {
  return (
    <div className="breadcrumbs link-container">
      {crumbs.map((crumb, index) => (
        <div className="breadcrumb" key={crumb.label}>
          {crumb.linkTo ? (
            <Link to={crumb.linkTo}>{crumb.label}</Link>
          ) : (
            <span>{crumb.label}</span>
          )}
          {index < crumbs.length - 1 ? (
            <ArrowRight className="breadcrumbs__arrow" width="1rem" height="1rem" />
          ) : null}
        </div>
      ))}
    </div>
  );
}

Breadcrumbs.propTypes = {
  crumbs: PropTypes.arrayOf(
    PropTypes.shape({
      linkTo: PropTypes.string,
      label: PropTypes.string
    })
  ).isRequired
};

export default Breadcrumbs;



// WEBPACK FOOTER //
// ./src/components/Breadcrumbs.js